import React from 'react';
import useQueryString from 'hooks/useQueryString';
import useSuspendableQuery from 'hooks/useSuspendableQuery';
import { useLocation } from 'react-router';
import qs from 'util/qs';
import {
  GetCourseCollectionsDocument,
  GetCourseCollectionsQuery,
} from '__generated__/graphql';

interface CollectionData {
  coursesCollectionSearch: GetCourseCollectionsQuery['coursesCollectionSearch'];
}

export function useCollectionSearch(): [
  CollectionData,
  number,
  (page: number) => string,
] {
  const { page, ...queryString } = useQueryString();
  const { pathname } = useLocation();

  const variables = React.useMemo(() => {
    return {
      page,
    };
  }, [page]);

  const { data } = useSuspendableQuery(GetCourseCollectionsDocument, {
    variables,
  });

  const href = React.useCallback(
    (page: number) =>
      `${pathname}?${qs.stringify({
        ...queryString,
        page,
      })}`,
    [pathname, queryString],
  );

  const filteredData = React.useMemo(() => {
    return {
      ...data,
      coursesCollectionSearch: {
        ...data.coursesCollectionSearch,
        edges: data.coursesCollectionSearch?.edges?.filter(
          (
            collection: NonNullable<
              NonNullable<
                GetCourseCollectionsQuery['coursesCollectionSearch']
              >['edges']
            >[number],
          ) => collection?.active,
        ),
      },
    };
  }, [data]);

  return [filteredData, page, href];
}
